export const ADD_ORDER = 'ADD_ORDER';

export const Status = {
    paid: 'paid',
};
